import React, {useEffect, useState} from 'react';
import {
  PartnerFavoriteWidget,
  usePulsoidClient,
} from '../../../../PulsoidClient';
import {PartnerPreviewFavorite} from './PartnerPreviewFavorite';
import {resolveWidget} from '../../../configuration/utils';
import css from './PartnerPreviewFavorite.module.css';
import {redirectToAuth} from '../../../../utils/locationUtils';
import {buildRoute} from '../../../navigation/navigationUtils';
import {DASHBOARD_ROUTES} from '../../../navigation/dashboard/DashboardRoutes';
import {useDemoPulse} from '../../../../hooks/useDemoPulse';

type PartnerPreviewFavoriteWidgetProps = {
  widget: PartnerFavoriteWidget;
  isUserLoggedIn?: boolean;
};

export const PartnerPreviewFavoriteWidget = ({
  widget,
  isUserLoggedIn,
}: PartnerPreviewFavoriteWidgetProps) => {
  const pulsoidPublicClient = usePulsoidClient({publicRpc: true});
  const [widgetConfig, setWidgetConfig] = useState(null);
  const [widgetMetaId, setWidgetMetaId] = useState(null);
  const demoPulse = useDemoPulse();

  const id = widget?.widgetId;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const widgetResponse = await pulsoidPublicClient.getWidget(id);
        setWidgetConfig(widgetResponse.configuration);
        setWidgetMetaId(widgetResponse.metaId);
      } catch (error) {
        console.error('Error fetching widget config', error);
      }
    };

    fetchData();
  }, [id]);

  const copyWidgetToCurrentUser = async () => {
    if (!isUserLoggedIn) {
      redirectToAuth({registration: true, newTab: true});
    } else {
      window.open(
        buildRoute({
          path: DASHBOARD_ROUTES.CONFIGURATION_CLONE_WIDGET,
          params: {predefinedWidgetId: id},
        }),
        '_blank'
      );
    }
  };

  return (
    <PartnerPreviewFavorite onClick={copyWidgetToCurrentUser}>
      <div className={css.widget}>
        {resolveWidget(widgetConfig, widgetMetaId, id, demoPulse, false)}
      </div>
    </PartnerPreviewFavorite>
  );
};
